import i18n from '@dms/i18n';

import {AUCTION_DEFAULT_ORDER_ID} from './AUCTION_DEFAULT_ORDER_ID';
import {USER_LIST_DEFAULT_ORDER_ID} from './USER_LIST_DEFAULT_ORDER_ID';

const AUCTION_SORT_BY = [
  {
    id: AUCTION_DEFAULT_ORDER_ID,
    name: i18n.t('entity.auction.labels.sortByEndTimeSoonest'),
    orderBy: ['car_end_time'],
  },
  {
    id: 'HIGHEST_MARGIN',
    name: i18n.t('entity.auction.labels.sortByHighestMargin'),
    orderBy: ['-margin'],
  },
  {
    id: 'PRICE_ASC',
    name: i18n.t('entity.vehicle.labels.sortByLowestPrice'),
    orderBy: ['price_actual'],
  },
  {
    id: 'PRICE_DESC',
    name: i18n.t('entity.vehicle.labels.sortByHighestPrice'),
    orderBy: ['-price_actual'],
  },
  {
    id: 'LOWEST_MILEAGE',
    name: i18n.t('entity.vehicle.labels.sortByLowestMileage'),
    orderBy: ['mileage_range'],
  },
  {
    id: 'NEWEST_CAR',
    name: i18n.t('entity.vehicle.labels.sortByNewestCar'),
    orderBy: ['-year'],
  },
  {
    id: 'FEATURE_RANK',
    name: i18n.t('entity.vehicle.labels.sortByFeatureRank'),
    orderBy: ['-feature_score'],
  },
];

/**
 * Derived once at module load -- stable reference passed to SourcingTable each render.
 * Avoids allocating a new array + 5 objects on every component re-render.
 */
export const AUCTION_SORT_OPTIONS = AUCTION_SORT_BY.map((item) => ({
  value: item.id,
  label: item.name,
  orderBy: item.orderBy,
}));

/**
 * O(1) lookup: sort id -> orderBy param string.
 * Replaces the per-render Array.find() call.
 */
export const AUCTION_ORDER_BY_MAP = new Map(AUCTION_SORT_BY.map((item) => [item.id, item.orderBy]));

const AUCTION_USER_LIST_SORT_BY = [
  {
    id: USER_LIST_DEFAULT_ORDER_ID,
    name: i18n.t('entity.vehicle.labels.sortByLastAdded'),
    orderBy: [] as string[],
  },
  ...AUCTION_SORT_BY,
];

/**
 * Sort options for user list pages (Favourites, To Buy, Hidden).
 * Prepends "Last added" as the default before the standard auction sort options.
 */
export const AUCTION_USER_LIST_SORT_OPTIONS = AUCTION_USER_LIST_SORT_BY.map((item) => ({
  value: item.id,
  label: item.name,
  orderBy: item.orderBy,
}));

/**
 * O(1) lookup for user list pages: sort id -> orderBy param string.
 */
export const AUCTION_USER_LIST_ORDER_BY_MAP = new Map(
  AUCTION_USER_LIST_SORT_BY.map((item) => [item.id, item.orderBy])
);
